<template>
  <vxe-grid
    size="small"
    row-id="shipmentContainerCode"
    border
    resizable
    auto-resize
    show-overflow
    highlight-hover-row
    :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
    :data="displayData"
    :columns="tableColumns"
    :loading="loading"
    :height="tableHeight"
  >
    <template #toolbar_form>
      <slot name="header" />
    </template>

    <template #containerName="{ row }">
      <el-tag size="small">
        {{ row.containerName || '-' }}
      </el-tag>
    </template>

    <template #extendParameterType="{ row }">
      <el-tag size="small" type="danger">
        {{ row.extendParameterTypeName || '-' }}
      </el-tag>
    </template>

    <template #volumeUsageRate="{ row }">
      <span class="pct-cell" :class="rateClass(row.volumeUsageRate)">
        <span
          class="pct-bar"
          :style="{
            width: Math.min(Number(row.volumeUsageRate || 0) * 100, 100) + '%',
          }"
        />
        <span class="pct-text">
          {{ (Number(row.volumeUsageRate || 0) * 100).toFixed(0) }}%</span
        >
      </span>
    </template>

    <template #weightUsageRate="{ row }">
      <span class="pct-cell" :class="rateClass(row.weightUsageRate)">
        <span
          class="pct-bar wt"
          :style="{
            width: Math.min(Number(row.weightUsageRate || 0) * 100, 100) + '%',
          }"
        />
        <span class="pct-text">
          {{ (Number(row.weightUsageRate || 0) * 100).toFixed(0) }}%</span
        >
      </span>
    </template>

    <template #expand="{ row }">
      <div style="background: #f9f9f9" class="py-2 pl-5 pr-2">
        <ContainerGoods :tableData="row.listGoods" />
      </div>
    </template>

    <template #containerNameHeader>
      <filter-content
        :text="$l('table_label_containerName') || '箱型'"
        :items="options.containerName"
        @filter="e => (filters.containerName = e)"
        submitFilterOnClose
      />
    </template>
    <template #editContainerNoHeader>
      <filter-content
        :text="$l('table_label_editContainerNo') || '编辑柜号'"
        :items="options.editContainerNo"
        @filter="e => (filters.editContainerNo = e)"
        submitFilterOnClose
      />
    </template>
    <template #containerNoHeader>
      <filter-content
        :text="$l('form_label_containerNo') || '集装箱号'"
        :items="options.containerNo"
        @filter="e => (filters.containerNo = e)"
        submitFilterOnClose
      />
    </template>
    <template #sealNoHeader>
      <filter-content
        :text="$l('form_label_sealNo') || '箱封号'"
        :items="options.sealNo"
        @filter="e => (filters.sealNo = e)"
        submitFilterOnClose
      />
    </template>
    <template #extendParameterTypeHeader>
      <filter-content
        :text="$l('table_label_expandParam') || '放大类型'"
        :items="options.extendParameterTypeName"
        @filter="e => (filters.extendParameterTypeName = e)"
        submitFilterOnClose
      />
    </template>
  </vxe-grid>
</template>

<script>
import { multiply } from '@/libs/util.number'
import ContainerGoods from '../container-goods/index.vue'
import TableAutoHeight from '@/mixins/table-auto-height'
import {
  applyTableFilters,
  buildFilterOptions,
  resetTableFilters,
} from '../table-filter-helpers'
import tableColumns from './table-columns'

export default {
  mixins: [TableAutoHeight],
  components: { ContainerGoods },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      filters: {
        containerName: [],
        editContainerNo: [],
        containerNo: [],
        sealNo: [],
        extendParameterTypeName: [],
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    options() {
      return buildFilterOptions(this.tableData, Object.keys(this.filters))
    },
    displayData() {
      return applyTableFilters(this.tableData, this.filters, this.options)
    },
  },
  watch: {
    tableData() {
      this.resetFilters()
    },
  },
  methods: {
    resetFilters() {
      this.filters = resetTableFilters(this.filters)
    },
    rateClass(val) {
      const pct = multiply(val || 0, 100)
      if (pct > 95) return 'pct-danger'
      if (pct > 75) return 'pct-warn'
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.pct-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 70px;
}
.pct-bar {
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(90deg, #409eff, #60a5fa);
  transition: width 0.3s;
  min-width: 2px;
  &.wt {
    background: linear-gradient(90deg, #10b981, #34d399);
  }
}
.pct-warn .pct-bar {
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
}
.pct-danger .pct-bar {
  background: linear-gradient(90deg, #f59e0b, #ef4444);
}
.pct-text {
  font-size: 11px;
  font-weight: 600;
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  color: #64748b;
  white-space: nowrap;
}
.pct-warn .pct-text {
  color: #f59e0b;
}
.pct-danger .pct-text {
  color: #ef4444;
}
</style>
